import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Country, CreateBusinessRequest } from '@acs/shared';
import {
  activateBusiness,
  archiveBusiness,
  createBusiness,
  setBusinessRegion,
} from '../../shared/api/businesses.js';
import { keys } from '../../shared/api/keys.js';

export function useCreateBusiness() {
  return useMutation({ mutationFn: (input: CreateBusinessRequest) => createBusiness(input) });
}

export function useActivateBusiness() {
  return useMutation({ mutationFn: (businessId: string) => activateBusiness(businessId) });
}

export function useArchiveBusiness() {
  return useMutation({ mutationFn: (businessId: string) => archiveBusiness(businessId) });
}

/**
 * Change the business's country. Server-owned because it also moves the
 * scheduling timezone, and is refused once a national number is held (doc 13a).
 */
export function useSetBusinessRegion(businessId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (country: Country) => setBusinessRegion(businessId, country),
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.business(businessId) }),
  });
}
